'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useAnalytics } from '@/hooks/useAnalytics';

export const PageTrackingProvider = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    // Obtener el título de la página
    const pageTitle = document.title || 'Hiperalia';
    
    // Construir la URL completa
    const pageLocation = window.location.href;
    const pagePath = pathname;

    // Trackear el page_view
    trackPageView({
      page_title: pageTitle,
      page_location: pageLocation,
      page_path: pagePath
    });
  }, [pathname, trackPageView]);

  return <>{children}</>;
};
